import React from "react";
import { connect } from "react-redux";
import {FormattedMessage} from "react-intl";
import PropTypes from "prop-types";

import LookListMainFeature from "../../../list/lookListMainFeature";
import {getMinAndMaxDays} from "./shippingTimes";
import {groheCartDeliveryInterface} from "./groheCartDeliveryInterface";


const GroheCartDeliverySection = (props) => {

  const {delivery, cartItems} = props;

  const deliveryCartItems = delivery.cartItems
    .map(cartItemId => cartItems.find(cartItem => cartItem.id === cartItemId))
    .filter(cartItem => cartItem)

  const {fromToString} = getMinAndMaxDays(deliveryCartItems);

  return (
    <div className="gc-section">
      <h4 className="gc-delivery__title">
        <FormattedMessage id="grohe.cart.delivery.estimation"/>: {fromToString}
      </h4>
      <ul className="gc-section__list">
        {deliveryCartItems.map(cartItem => {
          return <LookListMainFeature cartItem={cartItem} key={cartItem.id} withShipping={true}/>
        })}
      </ul>
    </div>
  )
};

GroheCartDeliverySection.propTypes = {
  delivery: PropTypes.shape(groheCartDeliveryInterface).isRequired,
}

const mapStateToProps = (store) => {
  const {cartItems} = store.cartState;
  return {
    cartItems,
  };
};

export default connect(mapStateToProps)(GroheCartDeliverySection)
